import { employeeHiringLink } from './employeeHiringLink';

export const pt = {
  ...employeeHiringLink,
};
